import css from '../topNavigationLayout.module.css'
import { PropsWithChildren } from 'react'

interface IProps {
  menu: JSX.Element
}

const TopNavigationLayoutFullscreenContentWithLeftMenu = (props: PropsWithChildren<IProps>) => {
  return (
    <div className={css.fullscreenContentWithMenuWrapper}>
      <div className={css.fullscreenContentMenuWrapper}>{props.menu}</div>
      <div className={css.fullscreenContentWrapper}>{props.children}</div>
    </div>
  )
}

export default TopNavigationLayoutFullscreenContentWithLeftMenu
